var React = require('react');

function Right (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1001_6992)","key":0},React.createElement("path",{"d":"M3.63176 0.095258L3.09524 0.631754C2.96825 0.758738 2.96825 0.964633 3.09524 1.09164L7.99191 6L3.09524 10.9083C2.96825 11.0353 2.96825 11.2412 3.09524 11.3682L3.63176 11.9048C3.75874 12.0317 3.96464 12.0317 4.09165 11.9048L9.76646 6.22995C9.89344 6.10297 9.89344 5.89708 9.76646 5.77007L4.09165 0.095258C3.96464 -0.0317527 3.75874 -0.0317527 3.63176 0.095258Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1001_6992"},React.createElement("rect",{"width":"12","height":"12"})))]);
}

Right.defaultProps = {"viewBox":"0 0 12 12","fill":"none"};

module.exports = Right;

Right.default = Right;
